__turbopack_context__.v({
  "bottomSheetHeading": "CallbackRequest-module-scss-module__JDH2ka__bottomSheetHeading",
  "callbackRequestHeader": "CallbackRequest-module-scss-module__JDH2ka__callbackRequestHeader",
  "toggleButton": "CallbackRequest-module-scss-module__JDH2ka__toggleButton",
});
